import { Navigate, useLocation } from "react-router-dom";

/**
 * Global trailing-slash stripper.
 *
 * Mounted once at the top of <BrowserRouter>. If the current pathname ends with
 * a trailing slash (and isn't just "/"), it redirects to the slash-less form
 * preserving search + hash. This lets the SEO blueprint's `/house-removals-uk/`
 * style URLs reach our canonical `/house-removals-uk` (and from there the
 * service redirect rules pass them on to the real canonical page).
 *
 * Client-side <Navigate replace> — Googlebot treats this as a permanent URL
 * substitution for ranking-equity purposes.
 */
export default function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();
  if (pathname.length > 1 && pathname.endsWith("/")) {
    const target = pathname.replace(/\/+$/, "") + (search || "") + (hash || "");
    return <Navigate to={target} replace />;
  }
  // Case normaliser: /FAQs, /House-Removals etc. → lowercase canonical path
  // (React Router matches case-insensitively, which lets uppercase duplicates render)
  if (/[A-Z]/.test(pathname)) {
    return <Navigate to={pathname.toLowerCase() + (search || "") + (hash || "")} replace />;
  }
  return null;
}
